import { GetProp, TablePaginationConfig, TableProps } from 'antd';

import { Role } from 'models/Role';
import { TiendaPerfectaDistributorTier } from 'models/TiendaPerfecta';

export const PAGE_SIZE = 10;

/**
 * Body que los modales entregan a la escena. Los campos de Tienda Perfecta
 * viajan siempre explícitos —`null` cuando la compañía no tiene la integración
 * habilitada— así el formulario es la única fuente de verdad de lo que se
 * guarda. La compañía no viaja: el rol la hereda de la suya.
 */
export interface RoleFormPayload {
  name: string;
  description: string | null;
  isDefaultRoleForStartedAccount: boolean;
  kitCampaignsFullAccessEnabled: boolean;
  campaignIds: number[];
  tiendaPerfectaDistributorTier: TiendaPerfectaDistributorTier | null;
  tiendaPerfectaDistributorIds: string[] | null;
}

export interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Parameters<GetProp<TableProps, 'onChange'>>[1];
}

export interface RoleModalHandlers {
  openDetailModal: (row: Role) => void;
  openMenuDetailModal: (row: Role) => void;
}
